// Auto-generated cornerstone translation for cs.
// Source: cornerstones/nl.js, translated via Claude Sonnet on 2026-05-28T13:59:57.701093+00:00.

export const CORNERSTONES = {
  beste: {
    seo: {
      title: "Aplikace pro správu koní: nejlepší volba pro rok 2026 | EquiSight",
      description: "Porovnejte aplikace pro správu koní pro majitele, stáje a chovatelství. Zjistěte, proč je EquiSight kompletní aplikace pro vašeho koně.",
      keywords: [
        "aplikace pro správu koní",
        "aplikace pro správu stáje",
        "koňský deník aplikace",
        "aplikace pro správu více koní",
        "aplikace sledování březosti klisny",
        "aplikace pro chov koní",
        "nejlepší aplikace pro správu koní",
      ],
    },
    hero: {
      eyebrow: "Průvodce výběrem · software pro správu koní",
      breadcrumbLabel: "Aplikace pro správu koní",
      title: "Aplikace pro správu koní: kompletní průvodce výběrem pro majitele, stáje a chovatelství.",
      intro: "Žádný prostý seznam funkcí — poctivé srovnání, průvodce výběrem a pohled na to, co aplikace pro správu koní skutečně musí umět v roce 2026. Pro jednoho koně, celou stáj nebo vaše chovatelství.",
      pills: [
        {
          icon: "Users",
          label: "Pro majitele",
        },
        {
          icon: "Building2",
          label: "Pro stáje",
        },
        {
          icon: "Baby",
          label: "Pro chovatelství",
        },
        {
          icon: "Share2",
          label: "Pro týmy",
        },
      ],
      ctas: [
        {
          label: "Začněte zdarma s 1 koněm",
          href: "#start",
          primary: true,
        },
        {
          label: "Přejít na srovnávací tabulku",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Proč je aplikace pro správu koní stále důležitější.",
      lead: "Správa koní je v praxi roztříštěná: WhatsApp, diář, Excel, fotky v telefonu, papírový pas, volné faktury a ústní dohody. Už u jednoho koně je to nepraktické. U více koní, chovatelství nebo sdílené péče vznikají mezery, zmeškaná setkání a spory.",
      items: [
        "Kdy přesně bylo to očkování?",
        "Kdo zaplatil podkovářovi?",
        "Kterou klisnu je dnes třeba zkontrolovat?",
        "Přečetl trenér vůbec pokyny z minulého týdne?",
        "Uložil jsem ten fotodokument opravdu správně?",
        "Je krmný plán visící ve stáji stále aktuální?",
      ],
    },
    what: {
      title: "Co je aplikace pro správu koní?",
      lead: "Aplikace pro správu koní je v podstatě digitální složka pro každého koně. Žádné roztříštěné poznámky, ale jedno místo pro zdraví, trénink, výživu, dokumenty, plánování, připomínky, náklady, fotky, videa a sdílený přístup. Každý okolo koně se dívá na stejné, aktuální informace.",
      targetGroupsTitle: "Pro koho je aplikace pro správu koní určena?",
      targetGroups: [
        {
          icon: "Heart",
          title: "Soukromý majitel",
          body: "Jeden kůň, jedna složka — zdraví, plánování a historie v kapse.",
        },
        {
          icon: "Users",
          title: "Majitel více koní",
          body: "Samostatné profily, samostatné plánování, sdílený seznam úkolů pro celý tým.",
        },
        {
          icon: "Building2",
          title: "Penzion a jezdecká škola",
          body: "Přístup majitelů, pokyny k ošetření, sdílený kalendář a úkoly.",
        },
        {
          icon: "Baby",
          title: "Chovatelství",
          body: "Cyklus klisny, březost, údaje o hřebcích, rodokmen a vývoj hříběte.",
        },
        {
          icon: "Target",
          title: "Trenéři",
          body: "Přehled o každém koni, zaznamenávání sezení, stanovování cílů, analýza videí.",
        },
        {
          icon: "ClipboardList",
          title: "Profesionálové",
          body: "Podkovář, zubař, fyzioterapeut nebo veterinář — pracují ze stejné složky.",
        },
      ],
    },
    criteria: {
      title: "Co musí dobrá aplikace pro správu koní splňovat?",
      lead: "Aplikace musí být nejen hezká — musí fungovat prakticky každý den. Pět součástí, které nesmí chybět při výběru v roce 2026.",
      items: [
        {
          icon: "FileText",
          title: "Složka pro každého koně",
          body: "Údaje, věk, plemeno, informace z pasu, majitel, stáj, fotky a dokumenty — vše propojeno s jedním profilem koně.",
        },
        {
          icon: "Heart",
          title: "Zdraví a ošetření",
          body: "Očkování, odčervení, podkovář, zubař, veterinář, ošetření, medikace a automatické připomínky před datem vypršení platnosti.",
        },
        {
          icon: "Activity",
          title: "Trénink a pokrok",
          body: "Zaznamenávání tréninků, poznámky, videa, výsledky ze závodů, cíle a pokrok v každé disciplíně nebo u každého koně.",
        },
        {
          icon: "Apple",
          title: "Výživa a management",
          body: "Krmné plány, doplňky, objemné krmivo, hmotnost, tělesná kondice a denní rutina, kterou stáj musí znát.",
        },
        {
          icon: "Share2",
          title: "Sdílení s ostatními",
          body: "Přístup pro majitele, ošetřovatele, trenéra, provozovatele stáje nebo profesionála — se správou práv odpovídající roli každého.",
        },
        {
          icon: "Calendar",
          title: "Plánování a připomínky",
          body: "Sdílený kalendář s úkoly, automatickými připomínkami a potvrzením, aby nic nepropadlo sítem.",
        },
      ],
    },
    comparison: {
      title: "EquiSight vs ostatní aplikace pro správu koní.",
      lead: "Český a evropský trh nabízí aplikace jako Stalmanager, LogMyHorse, EquineM a Happie Horse. Každá má své silné stránky. Nejžádanější funkce jsme srovnali vedle sebe — poctivě a na základě veřejně dostupných informací.",
      competitors: [
        "EquiSight",
        "Stalmanager",
        "LogMyHorse",
        "EquineM",
        "Happie Horse",
      ],
      rows: [
        {
          label: "Začít zdarma",
          values: [
            true,
            true,
            true,
            false,
            true,
          ],
        },
        {
          label: "Více koní",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Zdravotní složka",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Trénink a pokrok",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Výživa a doplňky",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Plánování a připomínky",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Dokumenty ke každému koni",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Sdílení s týmem a správa práv",
          values: [
            true,
            true,
            false,
            true,
            false,
          ],
        },
        {
          label: "Modul chovatelství (kompletní)",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Cyklus klisny",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Plánování březosti + ultrazvuky",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Vývoj hříběte",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Integrace profesionálů",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Přehledy EquiCoach",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Vhodné pro majitele",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Vhodné pro chovatelství",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Vhodné pro stáj/jezdeckou školu",
          values: [
            true,
            true,
            false,
            true,
            false,
          ],
        },
      ],
      note: "Srovnání na základě veřejně dostupných funkcí v lednu 2026. Konkurenční aplikace jsou také dobré nástroje; EquiSight je postavena tak, aby spojovala všechny moduly v jedné aplikaci.",
    },
    why: {
      title: "Proč je EquiSight jiná.",
      lead: "Deník zaznamenává. EquiSight kombinuje správu koní, trénink, výživu, zdraví, závody, profesionály a chovatelství v jedné moderní aplikaci — a jde o krok dál díky přehledům a analýzám.",
      points: [
        {
          icon: "Heart",
          title: "Jedna aplikace pro celý život koně",
          body: "Od hříběte po sportovního koně, chovnou klisnu nebo koně v penzi. Složka roste s vaším koněm — nic se cestou neztratí.",
        },
        {
          icon: "Sparkles",
          title: "Nejen data, ale i vzory",
          body: "EquiCoach kombinuje vývoj, opakující se obtíže, trénink a výživu — takže včas vidíte signály, ne jen ojedinělá hlášení.",
        },
        {
          icon: "Share2",
          title: "Postavena pro spolupráci",
          body: "Majitel, provozovatel stáje, trenér, podkovář a další profesionálové pracují ze stejné složky koně — s právy odpovídajícími jejich roli.",
        },
      ],
    },
    nicheA: {
      eyebrow: "Specializace · chovatelství",
      title: "Správa koní pro chovatelství.",
      lead: "Většina konkurentů zmíní chovatelství jednou větou. EquiSight vybudovala kompletní modul chovatelství — protože chovatel zřídkakdy je cílovým uživatelem obecné aplikace, ale plánování potřebuje víc než kdokoli jiný.",
      items: [
        "Denní sledování cyklu klisny",
        "Datum inseminace + údaje o hřebci",
        "Kontrola březosti s ultrazvuky",
        "Očekávané datum porodu + upozornění",
        "Vývoj hříběte po měsících",
        "Rodokmen a původ",
        "Poznámky ke každé klisně",
        "Přehled všech březích klisen",
      ],
      ctaLabel: "Prohlédnout modul chovatelství",
      ctaHref: "/fokkerij",
    },
    nicheB: {
      eyebrow: "Specializace · stáj a jezdecká škola",
      title: "Správa více koní a pensionních stájí.",
      lead: "U více koní jde méně o data a více o komunikaci. Každý majitel má vlastní přání, rutiny, krmné dohody a zdravotní specifika. Každý zaměstnanec by k nim měl mít přístup bez zdlouhavého hledání.",
      cards: [
        {
          t: "Koně podle majitele",
          d: "Každý majitel vidí pouze svého koně (své koně).",
        },
        {
          t: "Pokyny k ošetření",
          d: "Viditelné pro stáj u každého koně.",
        },
        {
          t: "Sdílený kalendář",
          d: "Podkovář, veterinář a závody v jednom přehledu.",
        },
        {
          t: "Seznam úkolů",
          d: "Přiřazení zaměstnancům s potvrzením.",
        },
        {
          t: "Přístup majitele",
          d: "Zákazníci vidí svého koně ve vlastní aplikaci.",
        },
        {
          t: "Nouzové kontakty",
          d: "Vždy po ruce v krizové situaci ve stáji.",
        },
      ],
      ctaLabel: "Prohlédnout modul pro jezdecké školy",
      ctaHref: "/manege-module",
    },
    beforeAfter: {
      title: "Z WhatsAppu, Excelu a tabule do EquiSight.",
      lead: "Konkrétně: takto se změní vaše každodenní správa koní.",
      rows: [
        {
          before: "Skupiny na WhatsApp",
          after: "Strukturované poznámky ke každému koni",
        },
        {
          before: "Tabulky v Excelu",
          after: "Živá složka koně s historií",
        },
        {
          before: "Tabule ve stáji",
          after: "Sdílené plánování v telefonu",
        },
        {
          before: "Volné fotky v telefonu",
          after: "Média propojená s vaším koněm",
        },
        {
          before: "Ústní dohody",
          after: "Úkoly a připomínky s potvrzením",
        },
        {
          before: "Ztracený papírový pas",
          after: "Dokumenty vždy po ruce",
        },
      ],
    },
    helper: {
      title: "Která aplikace pro správu koní je pro vás ta pravá?",
      lead: "Odpovězte na těchto 5 otázek a získáte poctivé doporučení — i v případě, že to nebude vždy EquiSight.",
      questions: [
        {
          id: "horses",
          q: "Máte jednoho koně nebo více koní?",
          options: [
            {
              label: "Jednoho koně",
              score: 1,
            },
            {
              label: "2–5 koní",
              score: 2,
            },
            {
              label: "Více než 5 koní",
              score: 3,
            },
          ],
        },
        {
          id: "clients",
          q: "Spravujete koně zákazníků nebo třetích stran?",
          options: [
            {
              label: "Ne, pouze vlastní koně",
              score: 0,
            },
            {
              label: "Občas — pro rodinu nebo známé",
              score: 1,
            },
            {
              label: "Ano, profesionálně (stáj / jezdecká škola)",
              score: 3,
            },
          ],
        },
        {
          id: "breeding",
          q: "Chcete sledovat chovatelství a březost?",
          options: [
            {
              label: "Není relevantní",
              score: 0,
            },
            {
              label: "Občas — příležitostný chov",
              score: 1,
            },
            {
              label: "Ano, jsem (nebo se stávám) chovatelem",
              score: 3,
            },
          ],
        },
        {
          id: "collab",
          q: "Spolupracujete s trenérem, ošetřovatelem nebo profesionálem?",
          options: [
            {
              label: "Ne, vše dělám sám",
              score: 0,
            },
            {
              label: "Ano, s 1 osobou",
              score: 1,
            },
            {
              label: "Ano, s více osobami",
              score: 3,
            },
          ],
        },
        {
          id: "depth",
          q: "Chcete pouze zaznamenávat, nebo také získávat přehledy?",
          options: [
            {
              label: "Pouze zaznamenávat",
              score: 1,
            },
            {
              label: "Zaznamenávat + plánovat",
              score: 2,
            },
            {
              label: "Zaznamenávat + plánovat + přehledy",
              score: 3,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Jednoduchý deník postačí — a roste s vámi.",
          body: "Pro jednoho koně bez sdílené péče je vhodná každá aplikace pro správu koní. EquiSight začíná zdarma s 1 koněm, takže neriskujete nic. Pokud budete chtít později přidat více koní, trenéra nebo chovatelství, vše už je v aplikaci připraveno.",
          cta: "Začněte zdarma s 1 koněm",
        },
        mid: {
          title: "EquiSight dobře odpovídá vaší situaci.",
          body: "Máte více potřeb (více koní, spolupráce nebo přehledy). Většina konkurentů pokrývá 1–2 moduly; EquiSight je kombinuje v jedné aplikaci, aniž byste museli propojovat různé nástroje.",
          cta: "Zjistěte, co EquiSight umí",
        },
        high: {
          title: "EquiSight je nejlogičtější volba.",
          body: "Vaše situace zahrnuje více koní, spolupráci, chovatelství a/nebo přehledy. Právě zde EquiSight dělá rozdíl — žádné roztříštěné nástroje, ale jedna složka koně pro vše a všechny okolo koně.",
          cta: "Začněte zdarma s EquiSight",
        },
      },
    },
    faqTitle: "Nejčastější otázky o aplikacích pro správu koní",
    faq: [
      {
        q: "Která aplikace pro správu koní je nejlepší?",
        a: "Nejlepší aplikace pro správu koní závisí na vaší situaci. Pro pouhý jednoduchý deník je vhodných více aplikací. Pokud chcete kombinovat zdraví, trénink, výživu, dokumenty, chovatelství, plánování a spolupráci, EquiSight je postavena jako kompletní řešení, kde se vše sbíhá do jedné složky.",
      },
      {
        q: "Mohu spravovat více koní v jedné aplikaci?",
        a: "Ano. Dobrá aplikace pro správu koní musí podporovat více koní, včetně majitelů, ošetřovatelů, rutin, dokumentů, schůzek a připomínek pro každého koně. EquiSight je na to navržena od prvního řádku kódu — koně jsou samostatné složky, ne řádky v seznamu.",
      },
      {
        q: "Je EquiSight vhodná i pro chovatelství?",
        a: "Ano. EquiSight lze nastavit s funkcemi pro chovatelství, jako je cyklus klisny, datum inseminace, kontrola březosti, údaje o hřebci, rodokmen, očekávané datum porodu a vývoj hříběte. To je přesně oblast, kde většina konkurenčních aplikací prakticky nefunguje.",
      },
      {
        q: "Mohu sdílet údaje s trenérem nebo podkovářem?",
        a: "Ano. Cílem EquiSight je, aby relevantní informace mohly být bezpečně sdíleny s lidmi okolo koně — trenérem, podkovářem, zubařem, veterinářem, fyzioterapeutem, ošetřovatelem nebo majitelem. Každá osoba dostane pouze taková práva, která jsou pro její roli potřebná.",
      },
      {
        q: "Proč nepoužívat jednoduše WhatsApp nebo Excel?",
        a: "WhatsApp a Excel fungují, dokud je vše jednoduché. Jakmile máte více koní, schůzky, dokumenty, ošetření, majitele nebo chovatelská data, stává se to náchylným k chybám: informace se rozptylují, dohledávání zabírá čas a ústní dohody mizí. Aplikace pro správu koní vše spojuje u každého koně s automatickými připomínkami.",
      },
      {
        q: "Kolik stojí EquiSight?",
        a: "Začít lze zdarma s 1 koněm. Pokud chcete spravovat více koní, aktivovat chovatelství nebo dát přístup profesionálům, existují dostupné prémiové plány. Aktuální možnosti najdete na stránce s cenami.",
      },
    ],
  },
  fokkerij: {
    seo: {
      title: "Software pro chov koní: kompletní srovnání 2026",
      description: "Porovnejte software pro chov koní: cyklus klisny, březost, výběr hřebce a hříbata. Zjistěte, proč je EquiSight kompletní aplikace pro chov koní.",
      keywords: [
        "software pro chov koní",
        "aplikace cyklus klisny",
        "aplikace březost klisny",
        "aplikace registrace hříběte",
        "aplikace plemenná kniha koní",
        "plánování připouštění koní",
        "aplikace výběr hřebce",
      ],
    },
    hero: {
      eyebrow: "Průvodce výběrem · software pro chov koní",
      breadcrumbLabel: "Software pro chov koní",
      title: "Software pro chov koní: kompletní srovnání pro rok 2026.",
      intro: "Chovná klisna si zaslouží víc než obecnou aplikaci pro správu koní. Porovnejte funkce pro chov nejznámějších nástrojů, zjistěte, na co skutečně záleží, a vědomě si vyberte software, který odpovídá vaší hřebčíně — velké i malé.",
      pills: [
        {
          icon: "Baby",
          label: "Cyklus klisny",
        },
        {
          icon: "Heart",
          label: "Kontrola březosti",
        },
        {
          icon: "Sparkles",
          label: "Vývoj hříběte",
        },
        {
          icon: "FileText",
          label: "Plemenná kniha",
        },
      ],
      ctas: [
        {
          label: "Začněte zdarma s modulem pro chov",
          href: "#start",
          primary: true,
        },
        {
          label: "Přejít na srovnávací tabulku",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Proč běžná aplikace pro správu koní nestačí pro chov.",
      lead: "Většina aplikací pro jezdecký sport je navržena pro jednoho sportovního nebo rekreačního koně. Chov má úplně jiný rytmus: říje, inseminace, kontrola březosti, ultrazvuky, kalendář hříbat, rodokmen a prodej. Jeden Excel se po 2 sezónách rozpadne — a při více klísnách ztrácíte přehled.",
      items: [
        "Kdy byl vlastně poslední cyklus Bonity?",
        "Který hřebec je naplánován pro připouštění příští sezónu?",
        "Je již naplánován ultrazvuk ve 21. dni?",
        "Která hříbata z roku 2024 jsou již prodána?",
        "Kde je diagram rodokmenu až po dědu z matčiny strany?",
        "Kde jsou vzorky DNA a údaje z pasu?",
      ],
    },
    what: {
      title: "Co je software pro chov koní?",
      lead: "Software pro chov koní je specializovaná složka pro každou klisnu a hřebce, kombinovaná s kalendářem chovné sezóny, plánováním březosti, registrací hříbat a zobrazením rodokmenu. Ne obecný zápisník o koních, ale nástroj, který rozumí chovnému cyklu: od první říje až po odstav.",
      targetGroupsTitle: "Pro jaký typ chovatele je software pro chov koní určen?",
      targetGroups: [
        {
          icon: "Baby",
          title: "Hobby chovatel (1–3 klisny)",
          body: "Jedno nebo dvě připouštění ročně — přehled bez akrobatiky v Excelu.",
        },
        {
          icon: "Building2",
          title: "Malá hřebčína (4–10 klisen)",
          body: "Plán chovné sezóny s cyklem, inseminací, kontrolami březosti a složkou hříběte.",
        },
        {
          icon: "Users",
          title: "Profesionální hřebčína (10+)",
          body: "Více zaměstnanců, výběr hřebce pro každou klisnu, prodej a marketing.",
        },
        {
          icon: "Target",
          title: "Majitel hřebce",
          body: "Historie objednávek, statistiky spermatu a kalendář pro každého hřebce.",
        },
        {
          icon: "Heart",
          title: "Embryotransfer",
          body: "Dárkyně + přijímající klisna jako propojená složka, kalendář ET.",
        },
        {
          icon: "ClipboardList",
          title: "Registrace v plemenné knize",
          body: "Vzorky DNA, dokumenty z pasu a údaje rodokmenu.",
        },
      ],
    },
    criteria: {
      title: "Co musí dobrý software pro chov koní splňovat?",
      lead: "Ne každá 'chovná funkce' v aplikaci pro koně je stejná. Pět klíčových oblastí, kde chovatelé ztrácejí nejvíce času — a kde software skutečně přináší rozdíl.",
      items: [
        {
          icon: "Calendar",
          title: "Cyklus klisny a říje",
          body: "Denní záznamy, prediktivní ovulace, pokračování po cyklu a automatické připomínky.",
        },
        {
          icon: "Heart",
          title: "Inseminace a kontrola březosti",
          body: "Data připouštění a inseminace, údaje o hřebci, ultrazvuk ve 14., 21., 60. dni a určení pohlaví.",
        },
        {
          icon: "Baby",
          title: "Vývoj hříběte",
          body: "Porodní údaje, graf hmotnosti, odčervovací plán, odstav, registrace pasu.",
        },
        {
          icon: "FileText",
          title: "Rodokmen a dokumenty",
          body: "Zobrazení rodokmenu až do 4–5 generací, DNA, čísla pasů a status v plemenné knize.",
        },
        {
          icon: "Target",
          title: "Výběr hřebce a párování",
          body: "Filtrování podle disciplíny, linií, údajů o hřebci a historických výsledků — nejen to, co propaguje majitel hřebce.",
        },
        {
          icon: "Share2",
          title: "Spolupráce s veterinářem/inseminátorem",
          body: "Ultrazvuky, vzorky a stavy sdíleny přímo s pracovištěm, které pečuje o vaše klisny.",
        },
      ],
    },
    comparison: {
      title: "EquiSight vs ostatní software pro chov koní.",
      lead: "Výsledky vyhledávání pro software pro chov koní často zobrazují obecné aplikace pro koně, které chov zmiňují jen okrajově. Spravedlivě porovnáváme, které nástroje skutečně mají kompletní chovný proces.",
      competitors: [
        "EquiSight",
        "Stalmanager",
        "HorseManager",
        "EquineGenie",
        "Foal-Excel",
      ],
      rows: [
        {
          label: "Začít zdarma",
          values: [
            true,
            true,
            false,
            false,
            true,
          ],
        },
        {
          label: "Záznam cyklu klisny",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Datum inseminace + hřebec",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Ultrazvuky a kontrola březosti",
          values: [
            true,
            false,
            true,
            true,
            false,
          ],
        },
        {
          label: "Očekávané datum porodu",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Složka hříběte (váha/růst)",
          values: [
            true,
            false,
            true,
            true,
            false,
          ],
        },
        {
          label: "Rodokmen do 4–5 generací",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Registrace DNA a pasu",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Výběr hřebce / párování",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "ET / embryotransfer",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Přehled více klisen",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Mobilní (iOS/Android)",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Sdílení s veterinářem",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Integrováno s obecnou složkou",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Prodej a marketing hříbat",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
      ],
      note: "Srovnání na základě veřejně dostupných funkcí v lednu 2026. EquineGenie je silný v chovu, ale méně v mobilním použití a obecné správě koní. EquiSight kombinuje obojí.",
    },
    why: {
      title: "Proč EquiSight slouží chovatelům jinak.",
      lead: "Mnoho chovatelů pracuje se samostatným softwarem pro chov a oddělenou aplikací pro správu koní. EquiSight kombinuje obojí — bez přepínání mezi aplikacemi nebo dvojitého zadávání dat.",
      points: [
        {
          icon: "Heart",
          title: "Chovná klisna zůstává i běžným koněm",
          body: "Chovná klisna má složku pro chovnou sezónu i běžnou koňskou složku — zdraví, očkování, podkovář. Jedna aplikace, všechny moduly.",
        },
        {
          icon: "Sparkles",
          title: "Prediktivně, ne reaktivně",
          body: "Předpověď cyklu, připomínky milníků březosti a kalendář hříbat — automaticky na základě vašich dat.",
        },
        {
          icon: "Share2",
          title: "Všichni kolem chovu",
          body: "Inseminátor, majitel hřebce, veterinář, kupující, plemenná kniha — všichni mají přístup se správnými oprávněními.",
        },
      ],
    },
    nicheA: {
      eyebrow: "Podle disciplíny · od cyklu po odstav",
      title: "Co složka pro chov v EquiSight obsahuje.",
      lead: "Každá klisna má kompletní chovnou složku propojenou s její běžnou koňskou složkou.",
      items: [
        "Denní záznam cyklu s předpovědí",
        "Inseminace/připouštění + údaje o hřebci",
        "Časová osa ultrazvuků (14/21/60 dní + pohlaví)",
        "Milníky březosti s automatickými připomínkami",
        "Očekávané datum porodu a příprava",
        "Složka hříběte od narození",
        "Rodokmen až po prarodiče s navigací proklikem",
        "Vzorek DNA, pas, status v plemenné knize",
        "Prodejní pipeline se zájemci",
        "Historie výběru hřebce pro každou klisnu",
      ],
      ctaLabel: "Prohlédnout modul pro chov",
      ctaHref: "/fokkerij",
    },
    nicheB: {
      eyebrow: "Pro celou hřebčínu",
      title: "Přehled pro více klisen a hřebců.",
      lead: "Když chováte více než 2–3 klisny, přehled o všech cyklech a březostech je zásadní.",
      cards: [
        {
          t: "Dashboard cyklů",
          d: "Všechny klisny vedle sebe s fází cyklu a dalším krokem.",
        },
        {
          t: "Pipeline březosti",
          d: "Které klisny jsou kde v milnících březosti?",
        },
        {
          t: "Kalendář hříbat",
          d: "Očekávané porody podle měsíce s přizpůsojenou logistikou.",
        },
        {
          t: "Portfolio hřebců",
          d: "Vlastní hřebci nebo stálí inseministoři s historií objednávek.",
        },
        {
          t: "Graf rodokmenu",
          d: "Analýza předků přes více generací a linií.",
        },
        {
          t: "Dashboard prodeje",
          d: "Která hříbata jsou prodána, rezervována nebo stále dostupná.",
        },
      ],
    },
    beforeAfter: {
      title: "Od Excelu a diáře k EquiSight pro chov.",
      lead: "Konkrétně: takto se změní vaše chovná sezóna.",
      rows: [
        {
          before: "Cyklus v samostatné poznámce",
          after: "Denní záznam s předpovědí",
        },
        {
          before: "Ultrazvuky přes WhatsApp inseminátorovi",
          after: "Sdílená složka s fotografiemi",
        },
        {
          before: "Datum březosti v diáři",
          after: "Automatické připomínky milníků",
        },
        {
          before: "Pas hříběte v zásuvce",
          after: "Dokument propojený s profilem hříběte",
        },
        {
          before: "Rodokmen na papíře",
          after: "Proklikatelný rodokmen do 4–5 generací",
        },
        {
          before: "Prodejní inzerát na Marktplaats",
          after: "Prodejní pipeline se seznamem zájemců",
        },
      ],
    },
    helper: {
      title: "Který software pro chov koní se hodí pro vás?",
      lead: "5 otázek, které vám pomohou zjistit, zda potřebujete kompletní aplikaci pro chov, nebo postačí hobby nástroj.",
      questions: [
        {
          id: "mares",
          q: "Kolik chovných klisen spravujete?",
          options: [
            {
              label: "1 klisna",
              score: 1,
            },
            {
              label: "2–5 klisen",
              score: 2,
            },
            {
              label: "Více než 5 klisen",
              score: 3,
            },
          ],
        },
        {
          id: "frequency",
          q: "Jak často chováte za rok?",
          options: [
            {
              label: "Příležitostně (jednou za několik let)",
              score: 0,
            },
            {
              label: "Každý rok 1–2 připouštění",
              score: 2,
            },
            {
              label: "Každý rok 3 a více připouštění",
              score: 3,
            },
          ],
        },
        {
          id: "method",
          q: "Jakou metodu inseminace/připouštění používáte?",
          options: [
            {
              label: "Přirozené připouštění",
              score: 1,
            },
            {
              label: "KI čerstvé/chlazené sperma",
              score: 2,
            },
            {
              label: "ET nebo zmražené sperma",
              score: 3,
            },
          ],
        },
        {
          id: "team",
          q: "Spolupracujete s veterinářem/inseminátorem?",
          options: [
            {
              label: "Jedna stálá osoba",
              score: 1,
            },
            {
              label: "Více pracovišť",
              score: 2,
            },
            {
              label: "Mezinárodní síť",
              score: 3,
            },
          ],
        },
        {
          id: "tracking",
          q: "Co nyní sledujete?",
          options: [
            {
              label: "Excel nebo papír",
              score: 1,
            },
            {
              label: "Obecná aplikace pro správu koní",
              score: 2,
            },
            {
              label: "Nic strukturovaného",
              score: 3,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Postačí hobby nástroj nebo Excel — ale EquiSight se stále hodí.",
          body: "Pro 1 klisnu s přirozeným připouštěním jednou za několik let je rozsáhlý modul pro chov zbytečný. EquiSight začíná zdarma a modul pro chov aktivujete pouze na rok, kdy připouštíte — bez povinnosti upgradu.",
          cta: "Začít zdarma",
        },
        mid: {
          title: "Modul pro chov EquiSight je ten pravý nástroj.",
          body: "Máte více klisen nebo více metod chovu — na to obecné aplikace pro koně nejsou stavěny. EquiSight kombinuje chov a obecnou péči, takže nepřepínáte mezi dvěma nástroji.",
          cta: "Prohlédnout modul pro chov",
        },
        high: {
          title: "EquiSight je vytvořen pro vaši hřebčínu.",
          body: "Více klisen, ET nebo zmražené sperma, mezinárodní tým — většina nástrojů zde nestačí. EquiSight roste s vaší hřebčínou bez nutnosti hromadění dalších licencí.",
          cta: "Promluvte s námi o plánu pro hřebčínu",
        },
      },
    },
    faqTitle: "Často kladené otázky o softwaru pro chov koní",
    faq: [
      {
        q: "Jaký je nejlepší software pro chov koní?",
        a: "Pro 1 klisnu bez složité chovné metody postačí mnoho nástrojů. Od 2–3 klisen, při použití KI nebo ET, nebo při spolupráci s veterinářem a plemennou knihou se kompletní modul pro chov stává zásadním. EquiSight kombinuje chov s obecnou správou koní v jedné aplikaci, takže nemusíte přepínat.",
      },
      {
        q: "Jaké chovné funkce skutečně potřebuji?",
        a: "Minimálně: záznam cyklu, údaje o inseminaci/připouštění, milníky kontroly březosti a složka hříběte. Volitelně, ale výkonně: zobrazení rodokmenu, archiv výběru hřebce, DNA/pas a prodejní pipeline.",
      },
      {
        q: "Dokáže EquiSight předpovědět cyklus klisny?",
        a: "Ano. EquiSight využívá předchozí data cyklu k zobrazení předpokládané ovulace, takže inseminaci nebo připouštění naplánujete ve správný čas — bez každodenního přemýšlení.",
      },
      {
        q: "Funguje EquiSight i pro embryotransfer?",
        a: "Ano. Dárkyně a přijímající klisna mají propojené složky, kalendář ET a sdílené milníky s pracovištěm. Takže neztratíte přehled v časové ose složitého procesu ET.",
      },
      {
        q: "Mohu importovat stávající chovná data?",
        a: "Cyklus, připouštění a data hříbat lze zadat ručně nebo hromadně přes CSV. U aktivních chovů pomáháme s jednorázovou migrací, pokud máte data za více sezón.",
      },
      {
        q: "Jak sdílím složku se svým veterinářem nebo inseminátorem?",
        a: "Každé osobě přidělíte přístup s rolí: veterinář, inseminátor, majitel hřebce nebo funkcionář plemenné knihy. Každý vidí pouze informace potřebné pro svou roli — není potřeba plný přístup.",
      },
    ],
  },
  manege: {
    seo: {
      title: "Software pro jezdecký klub: úplné srovnání & průvodce výběrem 2026",
      description: "Porovnejte software pro jezdecké kluby pro lekce, jezdce, koně a administrativu. Zjistěte, která aplikace se hodí pro váš jezdecký klub nebo pensionát.",
      keywords: [
        "software pro jezdecký klub",
        "aplikace pro správu stáje",
        "administrativní software pro jezdecký klub",
        "plánování lekcí jezdecký klub",
        "software pro pensionát",
        "administrativa jezdců",
        "administrativa koní jezdecký klub",
      ],
    },
    hero: {
      eyebrow: "Průvodce výběrem · software pro jezdecký klub",
      breadcrumbLabel: "Software pro jezdecký klub",
      title: "Software pro jezdecký klub: kompletní průvodce výběrem pro jezdecké kluby a pensionáty.",
      intro: "Plánování lekcí, administrativa jezdců, správa koní, fakturace a komunikace — dobrý software pro jezdecký klub to vše spojí dohromady. Porovnejte nejznámější možnosti a zjistěte, která se hodí pro vaši stáj nebo jezdecký klub.",
      pills: [
        {
          icon: "Calendar",
          label: "Plánování lekcí",
        },
        {
          icon: "Users",
          label: "Jezdci & klienti",
        },
        {
          icon: "Heart",
          label: "Péče o koně",
        },
        {
          icon: "CreditCard",
          label: "Fakturace",
        },
      ],
      ctas: [
        {
          label: "Požádat o demo",
          href: "#start",
          primary: true,
        },
        {
          label: "Přejít na srovnávací tabulku",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Proč roztříštěné nástroje zpomalují jezdecký klub.",
      lead: "Většina jezdeckých klubů funguje na záplatkách: plánování lekcí na tabuli, registrace jezdců v Excelu, fakturace v jiném nástroji, péče o koně přes WhatsApp a kontakt s majiteli přes osobní zprávy. V rušném týdnu vznikají dvojité rezervace, zapomenuté faktury nebo koně, kteří nevědí, kterého jezdce dostanou.",
      items: [
        "Kdo má teď hodinu u Jasmíny?",
        "Který jezdec ještě nezaplatil za březen?",
        "Který kůň se tento týden nesmí nasadit?",
        "Kdo jsou nouzové kontakty žáků?",
        "Dostal majitel koně Stardust již fakturu od kováře?",
        "Který kůň stojí v jakém boxu?",
      ],
    },
    what: {
      title: "Co je software pro jezdecký klub?",
      lead: "Software pro jezdecký klub kombinuje plánování lekcí, administrativu jezdců, správu koní, fakturaci a komunikaci v jednom nástroji. Žádná akrobacie v Excelu ani chaotické WhatsApp konverzace — jen jedno místo, kde jezdecký klub pracuje a majitelé/jezdci mají přehled.",
      targetGroupsTitle: "Pro jaký typ firmy je software pro jezdecký klub určen?",
      targetGroups: [
        {
          icon: "Building2",
          title: "Malý jezdecký klub (1–15 koní)",
          body: "Především plánování lekcí a platby — administrativa bez bolestí hlavy.",
        },
        {
          icon: "Users",
          title: "Středně velký jezdecký klub (15–40 koní)",
          body: "Více instruktorů, plánování lekcí + rozvrh koní + administrativa jezdců.",
        },
        {
          icon: "ClipboardList",
          title: "Velká jezdecká a penzionní stáj (40+)",
          body: "Kompletní provoz včetně fakturace, plánování krmení a kováře.",
        },
        {
          icon: "Heart",
          title: "Pensionát",
          body: "Portál pro majitele, individuální pokyny pro péči, sdílený kalendář.",
        },
        {
          icon: "Target",
          title: "Tréninkový klub skokového ježdění",
          body: "Plánování závodů, trénink pro každého koně, kontakt s klienty.",
        },
        {
          icon: "FileText",
          title: "Hipičtí podnikatelé",
          body: "Mix lekcí + penzionu + kliniky + obchodu — vše z jednoho systému.",
        },
      ],
    },
    criteria: {
      title: "Co musí dobrý software pro jezdecký klub splňovat?",
      lead: "Hezká aplikace nic neznamená, pokud s ní vaši zaměstnanci nechtějí pracovat. Pět praktických kritérií, která rozhodují mezi úspěchem a frustrací.",
      items: [
        {
          icon: "Calendar",
          title: "Plánování lekcí na více úrovních",
          body: "Začátečníci/pokročilí, drezura/skoky, přiřazení koní a kalendáře instruktorů — vše přehledně vedle sebe.",
        },
        {
          icon: "Users",
          title: "Administrativa jezdců",
          body: "Profily, úroveň, předplatné, permanentka a propojení rodinných příslušníků pro juniorské jezdce.",
        },
        {
          icon: "Heart",
          title: "Rozvrh koní",
          body: "Jak často je který kůň nasazován, s obdobími odpočinku, zranění a háření.",
        },
        {
          icon: "CreditCard",
          title: "Fakturace & předplatné",
          body: "Měsíční předplatné, permanentky, jednotlivé lekce a automatické inkaso.",
        },
        {
          icon: "Share2",
          title: "Portál pro majitele (pensionát)",
          body: "Majitelé vidí svého koně ve vlastní aplikaci — kalendář, náklady, kovář a poznámky bez telefonování.",
        },
        {
          icon: "Bell",
          title: "Komunikace & připomínky",
          body: "Automatické připomínky lekcí, upozornění na platby, oznámení kováře — bez posílání zpráv.",
        },
      ],
    },
    comparison: {
      title: "EquiSight vs ostatní software pro jezdecké kluby.",
      lead: "Mnoho nástrojů pro jezdecké kluby je silných v plánování lekcí nebo fakturaci, ale zřídka v péči o koně a komunikaci s majiteli zároveň. Porovnáváme je čestně vedle sebe.",
      competitors: [
        "EquiSight",
        "Stalmanager",
        "Equino",
        "Manege App",
        "Spreadsheet",
      ],
      rows: [
        {
          label: "Bezplatný start / zkušební doba",
          values: [
            true,
            true,
            false,
            true,
            true,
          ],
        },
        {
          label: "Plánování lekcí",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Více instruktorů",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Administrativa jezdců",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Rozvrh koní",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Péče o koně (vakcinace/kovář)",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Permanentka / předplatné",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Online platby",
          values: [
            true,
            true,
            true,
            false,
            false,
          ],
        },
        {
          label: "Automatická fakturace",
          values: [
            true,
            true,
            true,
            false,
            false,
          ],
        },
        {
          label: "Portál pro majitele (pensionát)",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Integrace kovář/veterinář",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Připomínky přes WhatsApp/SMS",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Mobilní aplikace (iOS/Android)",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Plánování závodů",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Vhodné pro pensionát",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
      ],
      note: "Srovnání na základě veřejně dostupných funkcí v lednu 2026. Stalmanager je silný v administrativě, EquiSight se odlišuje v pracovním postupu pensionátu + péče o koně + portál pro majitele.",
    },
    why: {
      title: "Proč je EquiSight pro jezdecké kluby a pensionáty jiný.",
      lead: "EquiSight jde dál než pouhý plánovač lekcí. Jezdecký klub vnímáme jako kompletní provoz: koně, lidé, komunikace a finance — vše navzájem propojené.",
      points: [
        {
          icon: "Heart",
          title: "Kůň v centru, ne kalendář",
          body: "Každý kůň má vlastní složku. Nasazení v lekcích, zdraví, kovář a závody na jedné časové ose — ne ve 3 oddělených nástrojích.",
        },
        {
          icon: "Share2",
          title: "Majitelé mají přehled bez telefonování",
          body: "Majitelé koní v pensionátu mají vlastní přehled: náklady, plánování, fotky a poznámky — ušetří 5–10 telefonátů týdně.",
        },
        {
          icon: "Bell",
          title: "Automatická komunikace",
          body: "Připomínka lekce, připomínka vakcinace, faktura — automaticky, přes aplikaci/e-mail/SMS. Žádné hromadné WhatsApp zprávy.",
        },
      ],
    },
    nicheB: {
      eyebrow: "Pro pensionát",
      title: "Co pensionát od EquiSightu získá.",
      lead: "Pensionáty mají jedinečné výzvy, které běžný software pro jezdecké kluby neřeší.",
      cards: [
        {
          t: "Portál pro majitele",
          d: "Každý majitel vidí pouze svého koně (koně), kalendář a náklady.",
        },
        {
          t: "Pokyny pro péči o každého koně",
          d: "Krmení, hrubé krmivo, doplňky, rozvrh dek — viditelné pro stáj.",
        },
        {
          t: "Sdílený kalendář",
          d: "Kovář, veterinář a návštěvy majitelů v jednom přehledu.",
        },
        {
          t: "Spotřební náklady na koně",
          d: "Podestýlka, krmení, jadrné krmivo přeúčtované každému majiteli.",
        },
        {
          t: "Nouzové kontakty koně",
          d: "Majitel + veterinář + kovář vždy dostupní pro stáj.",
        },
        {
          t: "Správa pastvy",
          d: "Kteří koně jdou na pastvinu, odpočívají nebo jsou v rehabilitaci?",
        },
      ],
    },
    beforeAfter: {
      title: "Od tabule + Excelu k EquiSightu.",
      lead: "Konkrétně: jak se změní pracovní týden v jezdeckém klubu.",
      rows: [
        {
          before: "Tabule s plánováním lekcí",
          after: "Živé plánování pro každého instruktora",
        },
        {
          before: "Excel s jezdci + poznámky z lekcí",
          after: "CRM klientů s historií lekcí",
        },
        {
          before: "WhatsApp majitelům",
          after: "Portál pro majitele pro jejich koně",
        },
        {
          before: "Měsíční inkaso ručně",
          after: "Automatická fakturace + iDEAL",
        },
        {
          before: "Péče o koně na nástěnce",
          after: "Pokyny pro péči o každého koně, sdílené",
        },
        {
          before: "Ústní dohoda s kovářem",
          after: "Plánování kováře s potvrzeními",
        },
      ],
    },
    helper: {
      title: "Který software pro jezdecký klub vám vyhovuje?",
      lead: "5 otázek, abyste zjistili, zda je EquiSight tou správnou platformou pro váš jezdecký klub nebo pensionát.",
      questions: [
        {
          id: "size",
          q: "Kolik koní máte ve svém podniku?",
          options: [
            {
              label: "Méně než 10",
              score: 1,
            },
            {
              label: "10–30",
              score: 2,
            },
            {
              label: "Více než 30",
              score: 3,
            },
          ],
        },
        {
          id: "type",
          q: "Jaká je vaše hlavní činnost?",
          options: [
            {
              label: "Především výuka ježdění",
              score: 1,
            },
            {
              label: "Pensionát (koně v penzionu)",
              score: 3,
            },
            {
              label: "Mix lekcí + pensionátu",
              score: 3,
            },
          ],
        },
        {
          id: "instructors",
          q: "S kolika instruktory pracujete?",
          options: [
            {
              label: "Pouze já sám/sama",
              score: 1,
            },
            {
              label: "2–3 instruktoři",
              score: 2,
            },
            {
              label: "4 nebo více",
              score: 3,
            },
          ],
        },
        {
          id: "billing",
          q: "Jak nyní řešíte fakturaci?",
          options: [
            {
              label: "Ručně (Word/Excel)",
              score: 3,
            },
            {
              label: "Samostatný účetní program",
              score: 2,
            },
            {
              label: "Integrováno v nástroji pro lekce",
              score: 1,
            },
          ],
        },
        {
          id: "owners",
          q: "Jak komunikujete s majiteli koní?",
          options: [
            {
              label: "Osobně / WhatsApp",
              score: 3,
            },
            {
              label: "E-mail + WhatsApp",
              score: 2,
            },
            {
              label: "Portál pro majitele v nástroji",
              score: 0,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Jednoduchý nástroj nebo Excel zatím postačí — ale EquiSight roste s vámi.",
          body: "Pro malý výukový podnik s jedním instruktorem a malým pensionátem není rozsáhlý balíček hned nutný. EquiSight začíná zdarma a roste společně s vaším jezdeckým klubem — žádné bolestivé migrace za pár let.",
          cta: "Začít zdarma",
        },
        mid: {
          title: "EquiSight je logický upgrade pro váš jezdecký klub.",
          body: "Více instruktorů, mix lekcí a pensionátu nebo fakturace, která teď stojí samostatně — EquiSight to vše spojí do jednoho pracovního postupu. Zejména portál pro majitele ušetří spoustu ad-hoc komunikace.",
          cta: "Požádat o demo",
        },
        high: {
          title: "EquiSight je stavěn pro váš rozsah.",
          body: "Pensionát + lekce + více instruktorů je přesně to, v čem se EquiSight odlišuje od klasických nástrojů pro jezdecké kluby. Portál pro majitele a integrace péče o koně šetří každý týden hodiny administrativy a komunikace.",
          cta: "Naplánovat demo pro vaši stáj",
        },
      },
    },
    faqTitle: "Často kladené otázky o softwaru pro jezdecké kluby",
    faq: [
      {
        q: "Jaký je nejlepší software pro jezdecký klub?",
        a: "Pro čisté plánování lekcí existuje několik dobrých možností. Jakmile potřebujete pensionát, více instruktorů nebo sledování péče o koně, stává se EquiSight kompletním řešením — žádné žonglování s nástroji, vše na jednom místě.",
      },
      {
        q: "Mohu importovat stávající klienty a lekce?",
        a: "Ano. Údaje o klientech a rozvrhy lekcí lze importovat přes CSV. Aktivním jezdeckým klubům pomáháme s jednorázovou migrací, abyste nemuseli ručně zadávat 200 jezdců.",
      },
      {
        q: "Funguje to i pro pensionát bez lekcí?",
        a: "Ano. Režim pensionátu vypne lekce a zaměří se na portál pro majitele, krmení/péči, plánování kováře a přeúčtování nákladů za každého koně.",
      },
      {
        q: "Mohou se jezdci sami přihlašovat a platit?",
        a: "Ano. Jezdci mohou prostřednictvím vlastního účtu vidět, které lekce jsou dostupné, přihlásit se, zaplatit školné pomocí iDEAL a koupit permanentky.",
      },
      {
        q: "Jak je to s ochranou osobních údajů koní a majitelů?",
        a: "Každá osoba má svou roli (majitel, jezdec, instruktor, zaměstnanec). Každá role vidí pouze to, co potřebuje. Majitelé vidí pouze svého koně, jezdci pouze vlastní lekce.",
      },
      {
        q: "Může EquiSight propojit s mým účetním softwarem?",
        a: "Ano, k dispozici jsou integrace s Exact, Moneybird a e-Boekhouden. Faktury pak automaticky přecházejí do vašeho účetnictví.",
      },
    ],
  },
  trainer: {
    seo: {
      title: "Trenérská aplikace pro koně: srovnání a průvodce výběrem pro kouče 2026",
      description: "Porovnejte trenérské aplikace pro koně a jezdce: tréninkový deník, video, cíle, analýza protokolů a správa klientů. Najděte ten správný nástroj pro kouče.",
      keywords: [
        "trenérská aplikace pro koně",
        "aplikace pro instruktory",
        "aplikace pro trénink koní",
        "aplikace pro koučování jezdců",
        "tréninkový deník koně",
        "analýza drezurního protokolu",
        "software pro trenéry koní",
      ],
    },
    hero: {
      eyebrow: "Průvodce výběrem · software pro trenéry",
      breadcrumbLabel: "Trenérská aplikace",
      title: "Trenérská aplikace pro koně: kompletní průvodce výběrem pro instruktory a kouče.",
      intro: "Trenér nebo instruktor žongluje s kombinacemi, lekcemi, videi, cíli a soutěžemi. Porovnejte nejlepší trenérské aplikace pro jezdecký svět a vyberte platformu, která bude růst spolu s vaším koučováním i v roce 2026.",
      pills: [
        {
          icon: "Target",
          label: "Cíle a plánování",
        },
        {
          icon: "Video",
          label: "Videoanalýza",
        },
        {
          icon: "TrendingUp",
          label: "Pokrok",
        },
        {
          icon: "Users",
          label: "Klienti/kombinace",
        },
      ],
      ctas: [
        {
          label: "Začněte zdarma jako trenér",
          href: "#start",
          primary: true,
        },
        {
          label: "Přejít na srovnávací tabulku",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Proč koučování přes WhatsApp trenérům překáží.",
      lead: "Většina trenérů pracuje s různými nástroji: WhatsApp pro komunikaci, zápisník pro lekce, YouTube nebo WeTransfer pro videa a Excel pro výsledky soutěží. U 5 jezdců to funguje. U 20 jezdců se informace ztrácejí, zapomínáte na cíle a ztrácíte přehled o individuálním pokroku.",
      items: [
        "Jaký cíl má Anouk na tuto sezónu?",
        "Jaké video jsem minulý měsíc poslal Bramovi?",
        "Viděla Lara analýzu protokolu z její poslední soutěže?",
        "Která kombinace trénuje kolikrát týdně?",
        "Přečetl si majitel Stardusta mé tréninkové pokyny?",
        "Kdy jsem naposledy dal zpětnou vazbu na kolísavý impuls?",
      ],
    },
    what: {
      title: "Co je trenérská aplikace pro koně a jezdce?",
      lead: "Trenérská aplikace kombinuje koučovací CRM (kombinace, lekce, cíle), tréninkový deník pro každého koně, videozpětnou vazbu, plánování soutěží a analýzu protokolů. Žádný oddělený WhatsApp/YouTube/Excel, ale jedna platforma, kde trenér a jezdec spolupracují.",
      targetGroupsTitle: "Pro jaký typ trenéra je to určeno?",
      targetGroups: [
        {
          icon: "Target",
          title: "Instruktor drezury",
          body: "Skenování protokolů, propojení komentářů rozhodčích s tréninkovými cíli, sledování pokroku.",
        },
        {
          icon: "Activity",
          title: "Trenér skokového ježdění",
          body: "Plánování parkurů, zpětná vazba po kolech, správa výšek pro každého koně.",
        },
        {
          icon: "Award",
          title: "Eventing kouč",
          body: "Tři disciplíny, tři plány – vše viditelné vedle sebe.",
        },
        {
          icon: "TrendingUp",
          title: "Výkonnostní kouč (sport)",
          body: "Sledování EPI, soutěže, cíle — pro vrcholové sportovce a jejich týmy.",
        },
        {
          icon: "Users",
          title: "Instruktor v jízdárně",
          body: "Skupinové lekce i individuální koučování v jedné aplikaci.",
        },
        {
          icon: "Heart",
          title: "Rekreační kouč",
          body: "Hipoterapie, začátečníci, majitelé s jedním koněm.",
        },
      ],
    },
    criteria: {
      title: "Co musí dobrá trenérská aplikace splňovat?",
      lead: "Trénování je lidská práce, ale správný nástroj vás zefektivní o 30–50 % a pomáhá jezdcům se zlepšovat i mezi lekcemi.",
      items: [
        {
          icon: "Users",
          title: "Správa kombinací",
          body: "Kůň a jezdec jako jedna jednotka, s úrovní, cíli, pokrokem a historií.",
        },
        {
          icon: "ClipboardList",
          title: "Poznámky z lekcí a cíle",
          body: "Ke každé lekci poznámka s klíčovými body, propojená s dlouhodobými cíli.",
        },
        {
          icon: "Video",
          title: "Videozpětná vazba",
          body: "Nahrajte video, označte momenty, přidejte mluvenou nebo písemnou zpětnou vazbu.",
        },
        {
          icon: "Target",
          title: "Analýza soutěží a protokolů",
          body: "Skenujte protokoly (KNHS/FEI), sledujte skóre podle disciplín, komentáře rozhodčích a trendy.",
        },
        {
          icon: "Calendar",
          title: "Plánování a permanentky",
          body: "Kalendář, platby, předplatná a automatické připomínky.",
        },
        {
          icon: "Share2",
          title: "Komunikace s jezdcem",
          body: "Jezdec vidí svou vlastní stránku s lekcemi, videi, cíli a zpětnou vazbou.",
        },
      ],
    },
    comparison: {
      title: "EquiSight vs ostatní trenérské aplikace.",
      lead: "Některé trenérské nástroje se zaměřují na náhradu WhatsAppu, jiné na analýzu protokolů. EquiSight kombinuje obojí s opravdovou složkou koně — takže jezdec se zlepšuje i mezi lekcemi.",
      competitors: [
        "EquiSight",
        "Coach Apps (algemeen)",
        "HorseTrainer Pro",
        "EquiPilot",
        "WhatsApp + Excel",
      ],
      rows: [
        {
          label: "Začít zdarma",
          values: [
            true,
            true,
            false,
            true,
            true,
          ],
        },
        {
          label: "Správa kombinací",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Poznámky z lekcí a zpětná vazba",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Dlouhodobé cíle",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Nahrávání videí a zpětná vazba",
          values: [
            true,
            true,
            true,
            false,
            false,
          ],
        },
        {
          label: "Skenování protokolů KNHS/FEI",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "EPI (výkonnostní index)",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Soutěžní kalendář",
          values: [
            true,
            false,
            true,
            true,
            false,
          ],
        },
        {
          label: "Portál pro jezdce",
          values: [
            true,
            true,
            false,
            true,
            false,
          ],
        },
        {
          label: "Permanentka / předplatné",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Online platby",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Integrovaná složka koně",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Viditelnost kováře/veterináře",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Pro instruktora I jezdce",
          values: [
            true,
            true,
            false,
            true,
            true,
          ],
        },
        {
          label: "Více koní na jezdce",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
      ],
      note: "Srovnání na základě veřejně dostupných funkcí v lednu 2026. EquiSight je jedinečný v analýze protokolů + EPI a zároveň to kombinuje s obecnou správou koní.",
    },
    why: {
      title: "Proč EquiSight nabízí jiný zážitek z koučování.",
      lead: "Většina trenérských nástrojů končí tam, kde končí lekce. EquiSight pokračuje dál — ve složce koně, v analýze soutěží, ve spolupráci s veterinářem a majitelem.",
      points: [
        {
          icon: "TrendingUp",
          title: "Skenování protokolu → tréninkový cíl",
          body: "Naskenujte protokol KNHS a ihned uvidíte, které disciplíny potřebují pozornost. Cíle se zobrazí automaticky.",
        },
        {
          icon: "Sparkles",
          title: "EquiCoach posiluje váš pohled",
          body: "Data z více lekcí, soutěží a protokolů odhalují vzorce, které si v hlavě neudržíte.",
        },
        {
          icon: "Share2",
          title: "Integrováno s koněm",
          body: "Trenér vidí historii očkování, kováře a zranění koně — žádné plánování tréninku v době rekonvalescence.",
        },
      ],
    },
    nicheA: {
      eyebrow: "Pro drezuru a skokové ježdění",
      title: "Co obsahuje koučovací složka v EquiSight.",
      lead: "Pro každou kombinaci získáte koučovací přehled, který drží vše pohromadě — už žádné ztracené věci ve WhatsAppu.",
      items: [
        "Poznámky z lekcí s klíčovými body každého sezení",
        "Dlouhodobé cíle a milníky",
        "Nahrávání videí s komentáři k časovým kódům",
        "Skenování protokolů KNHS/FEI se skóre",
        "Komentáře rozhodčích propojené s tréninkem",
        "Výsledky soutěží a trend EPI",
        "Kontakt s klientem a historie lekcí",
        "Permanentka / předplatné / faktury",
        "Graf pokroku podle disciplíny",
        "Sdílený přístup s majitelem koně",
      ],
      ctaLabel: "Zobrazit modul pro trenéry",
      ctaHref: "/trainer",
    },
    beforeAfter: {
      title: "Od WhatsAppu a YouTube k EquiSight Traineru.",
      lead: "Konkrétně: takto se změní váš koučovací pracovní postup.",
      rows: [
        {
          before: "WhatsApp s oddělenými odkazy na videa",
          after: "Video s zpětnou vazbou k časovým kódům ve složce",
        },
        {
          before: "Zápisník pro každého jezdce",
          after: "Koučovací deník s cíli a historií",
        },
        {
          before: "Excel s výsledky soutěží",
          after: "Graf EPI a analýza protokolů",
        },
        {
          before: "Ústní cíle",
          after: "Milníky s indikátorem pokroku",
        },
        {
          before: "Samostatný fakturační nástroj",
          after: "Lekce + iDEAL + předplatné v aplikaci",
        },
        {
          before: "E-mail majiteli o pokroku",
          after: "Majitel sleduje vývoj ve vlastním přehledu",
        },
      ],
    },
    helper: {
      title: "Která trenérská aplikace se hodí pro vás?",
      lead: "5 otázek, které ukážou, zda by specializovaný koučovací nástroj přinesl vaší praxi přidanou hodnotu.",
      questions: [
        {
          id: "clients",
          q: "Kolik aktivních kombinací koučujete?",
          options: [
            {
              label: "Méně než 5",
              score: 1,
            },
            {
              label: "5–15",
              score: 2,
            },
            {
              label: "Více než 15",
              score: 3,
            },
          ],
        },
        {
          id: "discipline",
          q: "Jaká je vaše hlavní disciplína?",
          options: [
            {
              label: "Drezura",
              score: 3,
            },
            {
              label: "Skokové ježdění",
              score: 2,
            },
            {
              label: "Rekreační / různé",
              score: 1,
            },
          ],
        },
        {
          id: "video",
          q: "Používáte při koučování video?",
          options: [
            {
              label: "Zřídka",
              score: 0,
            },
            {
              label: "Někdy (ručně)",
              score: 2,
            },
            {
              label: "Často — systematicky",
              score: 3,
            },
          ],
        },
        {
          id: "comp",
          q: "Koučujete závodní jezdce?",
          options: [
            {
              label: "Ne, rekreační",
              score: 0,
            },
            {
              label: "Občas soutěže",
              score: 2,
            },
            {
              label: "Hodně — startovní listiny jsou klíčové",
              score: 3,
            },
          ],
        },
        {
          id: "depth",
          q: "Chcete měřit své koučování?",
          options: [
            {
              label: "Ne, intuice stačí",
              score: 0,
            },
            {
              label: "Chtěl/a bych, ale nemám čas",
              score: 2,
            },
            {
              label: "Ano — koučování na základě dat",
              score: 3,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Jednoduchý nástroj nebo dokonce WhatsApp prozatím stačí.",
          body: "Pro méně než 5 jezdců bez většího využití videa nebo soutěží je koučovací aplikace zbytečná. EquiSight začíná zdarma, takže to můžete vyzkoušet, až vaše praxe poroste.",
          cta: "Začít zdarma",
        },
        mid: {
          title: "EquiSight Trainer vás systematicky zefektivní.",
          body: "U 5–15 kombinací ztrácíte každý měsíc hodiny na WhatsAppu a oddělených videích. EquiSight vše sdruží, automaticky skenuje protokoly a zajišťuje, že jezdci si mohou zpětnou vazbu kdykoli znovu prohlédnout.",
          cta: "Vyzkoušet modul Trainer",
        },
        high: {
          title: "EquiSight je vytvořen pro váš rozsah koučování.",
          body: "Hodně jezdců, video, soutěže a koučování na základě dat: přesně v tom se EquiSight odlišuje. EPI + skenování protokolů + složka koně vám dává náskok, který konkurenti nemají.",
          cta: "Naplánovat demo pro vaši koučovací praxi",
        },
      },
    },
    faqTitle: "Často kladené otázky o trenérských aplikacích",
    faq: [
      {
        q: "Jaká je nejlepší trenérská aplikace pro koně a jezdce?",
        a: "Pro čistou komunikaci postačí mnoho nástrojů (i WhatsApp). Pro cíle, videoanalýzu, skenování protokolů, sledování soutěží a správu klientů v jednom nástroji je EquiSight nejkomplexnějším řešením — zejména proto, že sleduje i samotného koně, nejen kombinaci.",
      },
      {
        q: "Dokáže EquiSight automaticky číst soutěžní protokoly?",
        a: "Ano. Nahrajte protokol KNHS nebo FEI a EquiSight extrahuje skóre podle disciplín, komentáře rozhodčích a propojí je s kombinací. Trendy vidíte napříč více soutěžemi.",
      },
      {
        q: "Co je EPI (Equestrian Performance Index)?",
        a: "EPI je skóre EquiSight, které převádí více soutěžních výsledků na srovnatelný výkonnostní index. Díky tomu vidíte skutečný pokrok napříč různými třídami a rozhodčími.",
      },
      {
        q: "Mohou si jezdci sami rezervovat a platit lekce?",
        a: "Ano. Jezdci se přihlásí, vidí dostupné časy lekcí, kupují permanentky a platí přes iDEAL. Vy rozhodujete, co chcete nabízet.",
      },
      {
        q: "Funguje to i pro instruktora, který pracuje v jízdárně?",
        a: "Ano. Jako freelance trenér můžete pracovat s vlastními klienty, aniž byste museli propojit účet jízdárny. Klienti vám platí přímo.",
      },
      {
        q: "Mohu přenést stávající videa a poznámky?",
        a: "Videa lze nahrát pro každou kombinaci nebo pomocí nástroje pro hromadné nahrávání. Poznámky importujte přes CSV. Aktivním trenérům pomáháme s jednorázovou migrací.",
      },
    ],
  },
  ui: {
    sectionEyebrows: {
      pains: "Proč to bolí",
      basics: "Základy",
      criteria: "Co to dělá dobrým?",
      comparison: "Férové srovnání",
      why: "Rozdíl",
      beforeAfter: "Od roztříštěnosti k přehledu",
      helper: "5 otázek",
    },
    table: {
      feature: "Funkce",
      today: "Dnes",
      withEquisight: "S EquiSight",
    },
    helper: {
      questionLabel: "Otázka {{current}} z {{total}}",
      answerPrompt: "Odpovězte na {{count}} zbývající otázku a zobrazí se vám doporučení.",
      answerPromptPlural: "Odpovězte na {{count}} zbývající otázky a zobrazí se vám doporučení.",
      resultEyebrow: "Váš výsledek",
    },
    targetGroupsFallback: "Pro koho je to určeno?",
    faqTitleFallback: "Často kladené otázky",
  },
  gidsen: {
    seo: {
      title: "Gidsen & keuzehulpen voor paardenbeheer software | EquiSight",
      description: "Alle EquiSight gidsen op één plek: paardenbeheer, fokkerij, manege en trainer software vergelijkingen plus keuzehulpen voor 2026.",
      keywords: [
        "paardensoftware gidsen",
        "paardenbeheer keuzehulp",
        "fokkerij software vergelijken",
        "manege software gids",
        "trainer app vergelijking",
      ],
    },
    hub: {
      eyebrow: "Hub · gidsen",
      breadcrumbLabel: "Gidsen",
      title: "Vier complete gidsen om de juiste paardensoftware te kiezen.",
      intro: "Voor iedere doelgroep een diepgaande keuzehulp: vergelijkingstabellen, criteria, voorbeelden en interactieve quiz. Klik door naar de gids die past bij jouw situatie, of verken eerst de verdiepende artikelen onder elke cluster.",
      stats: {
        guides: "4 keuzehulpen",
        articles: "15 verdiepende artikelen",
        fair: "Eerlijke vergelijking",
      },
      readMoreCta: "Lees de complete gids",
      relatedHeading: "Verdiepende artikelen",
      articlesCountSingular: "{{count}} verdiepend artikel",
      articlesCountPlural: "{{count}} verdiepende artikelen",
      articlesCountAria: "Aantal cluster-artikelen",
      lastUpdatedPrefix: "Bijgewerkt",
      lastUpdatedAria: "Datum laatste update van deze cluster",
    },
    clusters: [
      {
        path: "/beste-paardenbeheer-app",
        icon: "Compass",
        title: "Paardenbeheer app keuzehulp",
        blurb: "Vergelijk de bekendste paardenbeheer apps en ontdek welke past bij eigenaar, stal of fokkerij. Inclusief eerlijke vergelijkingstabel en 5-vragen keuzehulp.",
        audience: "Voor eigenaren, stalhouders en alle paardenmensen die overzicht zoeken.",
      },
      {
        path: "/fokkerij-software-paard",
        icon: "Baby",
        title: "Fokkerij software vergelijking",
        blurb: "Van merriecyclus tot veulenontwikkeling: bekijk welke fokkerij software echt werkt voor jouw aantal merries, fokmethode en stamboek-eisen.",
        audience: "Voor (hobby)fokkers, stoeterijen en hengstenhouders.",
      },
      {
        path: "/manege-software",
        icon: "Building2",
        title: "Manege software keuzehulp",
        blurb: "Lesplanning, ruiteradministratie, eigenaarsportaal en facturatie — in één tool. Vergelijk de opties voor maneges en pensionstallen in 2026.",
        audience: "Voor maneges, pensionstallen en rij-bedrijven.",
      },
      {
        path: "/trainer-app-paard",
        icon: "Target",
        title: "Trainer app keuzehulp",
        blurb: "Coaching-CRM, video-feedback, KNHS-protocol scannen en doelen per combinatie. Welke trainer app past bij jouw coaching praktijk?",
        audience: "Voor instructeurs, trainers en coaches.",
      },
    ],
    closing: {
      eyebrow: "Waarom deze gidsen",
      title: "Eerlijk vergelijken, niet alleen prijzen.",
      body1: "Veel \"vergelijkingspagina's\" zijn verkapte advertenties. Onze gidsen zetten functies, doelgroep en concurrenten naast elkaar zoals een onafhankelijke kennisbron dat zou doen. EquiSight komt natuurlijk naar voren als complete oplossing, maar je leest ook eerlijk waar andere apps sterker zijn.",
      body2: "De verdiepende artikelen onder elke gids beantwoorden de concrete vragen die voortkomen uit de keuze: \"Wanneer eerste echo na inseminatie\", \"Hoe automatiseer ik manege facturatie\", \"Hoe analyseer ik een wedstrijdprotocol\". Geen marketingfluff, wel praktijk.",
    },
    hubName: "EquiSight Gidsen",
  },
};

export default CORNERSTONES;
